// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"styles_itemTitle__4cHMQ","inputTitle":"styles_inputTitle__2ZYuC","autocomplete":"styles_autocomplete__2le9g","autocompleteInput":"styles_autocompleteInput__1hm_i"};